/* Haven page, conversion pass 2: "Why Haven" tabs, gift preview sheet, rating badge jump. Loaded after ce-suri.js. */
(function init(scope) {
  if (window.ceSuriPdpInit && window.ceSuriPdpInit !== init) return;
  if (!window.ceSuriPdpInit) {
    window.ceSuriPdpInit = init;
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
  var root = scope.id === 'ceSuri' ? scope : scope.querySelector('#ceSuri'); if (!root || root._ceSuriPdpReady) return;
  root._ceSuriPdpReady = true;

  /* ---------- Why Haven: one block, one panel at a time ---------- */
  var bar = root.querySelector('[data-why]');
  if (bar) {
    var defs = [['numbers', '.cs-nums'], ['compare', '.cs-compare'], ['experts', '.cs-adv'], ['sleeve', '.cs-5050']];
    var box = document.createElement('div'); box.className = 'cs-whybox';
    var panels = [];
    defs.forEach(function (d) {
      var el = root.querySelector(d[1]), tab = bar.querySelector('[data-why-tab="' + d[0] + '"]');
      if (!el || !tab) { if (tab) tab.remove(); return; }
      panels.push({ el: el, tab: tab });
    });
    if (panels.length > 1) {
      bar.parentNode.insertBefore(box, bar.nextSibling);
      panels.forEach(function (p, i) {
        box.appendChild(p.el);
        p.el.id = p.el.id || 'csWhy' + i; p.el.setAttribute('role', 'tabpanel');
        p.tab.setAttribute('aria-controls', p.el.id);
        p.tab.addEventListener('click', function () { show(i); });
      });
      var show = function (k) {
        panels.forEach(function (p, i) { p.el.hidden = i !== k; p.tab.setAttribute('aria-selected', String(i === k)); p.tab.tabIndex = i === k ? 0 : -1; });
        /* carousels inside a panel measure themselves when shown */
        window.dispatchEvent(new Event('resize'));
      };
      bar.hidden = false; show(0);
    }
  }

  /* ---------- gift tiles open a preview ---------- */
  var sheet = root.querySelector('[data-gift]');
  if (sheet) {
    var img = sheet.querySelector('[data-gift-img]'), kick = sheet.querySelector('[data-gift-k]'), name = sheet.querySelector('[data-gift-n]'), val = sheet.querySelector('[data-gift-v]'), btn = sheet.querySelector('[data-gift-btn]');
    var last = null, want = 0;
    /* the cart drawer can open this sheet over itself: closing keeps the drawer's scroll lock and puts focus back without scrolling the page */
    var close = function () { sheet.hidden = true; document.documentElement.style.overflow = document.querySelector('#csCart.is-open') ? 'hidden' : ''; if (last) { try { last.focus({ preventScroll: true }); } catch (x) { last.focus(); } } };
    var open = function (tile, from) {
      var tier = parseInt(tile.dataset.tier, 10) || 1, im = tile.querySelector('img'), locked = !from && tile.classList.contains('is-locked');
      var offerName = tier >= 5 ? sheet.dataset.o5 : sheet.dataset.o3;
      img.src = tile.dataset.img || im.getAttribute('src').replace(/width=\d+/, 'width=600'); img.alt = tile.dataset.n || im.alt;
      name.textContent = tile.dataset.n || im.alt || tile.querySelector('.cs-kit__n').textContent;
      /* brief 9: the gift rows in the bundle cards carry their name and value (data-n / data-v); the old kit tiles carried .cs-kit__v */
      if (tile.dataset.v) { val.innerHTML = '<b></b><span class="cs-strike"></span>'; val.firstChild.textContent = sheet.dataset.free || 'Free'; val.lastChild.textContent = tile.dataset.v; }
      else val.innerHTML = tile.querySelector('.cs-kit__v').innerHTML;
      kick.textContent = tier === 1 ? sheet.dataset.any : sheet.dataset.withOffer.replace('[offer]', offerName);
      want = locked ? tier : 0;
      btn.textContent = locked ? sheet.dataset.choose.replace('[offer]', offerName) : sheet.dataset.ok;
      last = from || tile; sheet.hidden = false; document.documentElement.style.overflow = 'hidden'; btn.focus({ preventScroll: true });
    };
    /* 2026-10-15: gift lines in the cart drawer open this sheet (they were dead taps). ceGiftOpen(handle or tile index 0-2, element to refocus);
       from the drawer the sheet never switches the offer, its button only closes it */
    var GIFT_TIER = { 'luluwala-silk-sleep-mask': 1, 'lux-unused-gift-2': 3, 'luluwala-satin-sleep-bonnet': 5 };
    /* brief 9: the kit tiles are gone; the cart drawer's sleeve, shoe cover and poncho lines open the sheet from the gift rows in the cards */
    /* Clarity 2026-10-15 (coordinator): no per-gift modals anywhere (41 "x" taps, loops before leaving); giftTile finds nothing, so the cart
       drawer's gift lines stay plain and the gift rows in the cards are not tappable. Set GIFT_SHEET = true to bring the sheet back. */
    var GIFT_SHEET = false;
    var giftTile = function (k) {
      if (!GIFT_SHEET) return null;
      if (typeof k === 'number') k = ['luluwala-silk-sleep-mask', 'lux-unused-gift-2', 'luluwala-satin-sleep-bonnet'][k];
      if (!GIFT_TIER[k]) return null;
      return root.querySelector('[data-hv-gift="' + k + '"]') || root.querySelector('[data-kit] .cs-kit__tile[data-tier="' + GIFT_TIER[k] + '"]');
    };
    /* 2026-10-24: window.ceGiftOpen now lives in ce-suri.js (the hv-gs gift sheet); this old kit sheet no longer claims it */
    /* 2026-10-15 brief 5: the gift tiles are in both copies of the picker (top and bottom), so every tile on the page opens the sheet */
    document.querySelectorAll('[data-kit] .cs-kit__tile').forEach(function (t) {
      t.setAttribute('role', 'button'); t.tabIndex = 0;
      t.addEventListener('click', function () { open(t); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(t); } });
    });
    btn.addEventListener('click', function () {
      var card = want && root.querySelector('.cs-offer[data-offer="' + want + '"]');
      close(); if (card) card.click();
    });
    sheet.querySelector('[data-gift-x]').addEventListener('click', close);
    sheet.addEventListener('click', function (e) { if (e.target === sheet) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) { e.preventDefault(); close(); } });
  }

  /* ---------- reviews by the offer: dots follow the swipe; the quotes turn by themselves until touched ---------- */
  var rv = root.querySelector('[data-revs-track]'), rd = root.querySelector('[data-revs-dots]');
  if (rv && rd && rv.children.length > 1) {
    var n = rv.children.length, cur = 0, touched = false, seen = false;
    for (var k = 0; k < n; k++) rd.appendChild(document.createElement('i'));
    var mark = function () { cur = rv.ceEmbla ? rv.ceEmbla.selectedScrollSnap() : 0; [].forEach.call(rd.children, function (d, i) { d.classList.toggle('is-on', i === Math.abs(cur)); }); };
    rv.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { rv.addEventListener(ev, function () { touched = true; }, { passive: true }); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { seen = e[0].isIntersecting; }, { threshold: 0.6 }).observe(rv);
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!calm) setInterval(function () { if (touched || !seen || document.hidden) return; var next = (cur + 1) % n; if (rv.ceEmbla) rv.ceEmbla.scrollTo(next); }, 5200);
    mark();
  }

  /* ---------- "In Numbers" cards: dots follow the swipe on phones ----------
     2026-10-15 v2: the cards now sit below the reviews, outside #ceSuri, so they are looked up in the page */
  var nt = root.querySelector('[data-nums-track]') || document.querySelector('[data-nums-track]'), nd = root.querySelector('[data-nums-dots]') || document.querySelector('[data-nums-dots]');
  if (nt && nd && nt.children.length > 1) {
    for (var q = 0; q < nt.children.length; q++) nd.appendChild(document.createElement('i'));
    var nmark = function () {
      var best = 0;
      if (nt.ceEmbla && nt.classList.contains('is-embla')) best = nt.ceEmbla.selectedScrollSnap();
      else { var x = Math.abs(nt.scrollLeft), x0 = nt.children[0].offsetLeft, bd = Infinity; for (var j = 0; j < nt.children.length; j++) { var dd = Math.abs(Math.abs(nt.children[j].offsetLeft - x0) - x); if (dd < bd) { bd = dd; best = j; } } }
      [].forEach.call(nd.children, function (d, i) { d.classList.toggle('is-on', i === best); });
    };
    nt.addEventListener('scroll', function () { requestAnimationFrame(nmark); }, { passive: true });
    window.addEventListener('resize', nmark); window.addEventListener('load', nmark);
    nmark();
  }

  /* ---------- rating badge and "read all reviews" scroll to the reviews ---------- */
  root.querySelectorAll('a[href="#judgeme_product_reviews"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
      if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      /* photos above load while the page glides and push the reviews down; land on the heading anyway */
      setTimeout(function () { if (Math.abs(t.getBoundingClientRect().top) > 40) t.scrollIntoView({ behavior: 'auto', block: 'start' }); }, 1000);
    });
  });

  /* 2026-10-25 owner ("it should open reviews aswell"): Clarity showed shoppers tapping the "Haven" title and the space around the
     stars ("Haven (23,720) Designed in ...") and nothing happening. A tap anywhere on that block now glides to the reviews like the
     stars do; the "Designed in Korea · Made in Japan" line keeps opening its own sheet. */
  var rateLink = root.querySelector('.hv-rate'), buyBox = root.querySelector('.cs-buy'), titleRow = root.querySelector('.cs-titlerow');
  if (rateLink && buyBox && titleRow) {
    buyBox.addEventListener('click', function (e) {
      if (e.target.closest('a,button,input,label,select,textarea')) return;
      var onTitle = e.target.closest('.cs-titlerow');
      if (!onTitle) {
        if (e.target !== buyBox) return;
        var last = root.querySelector('.hv-studio-origin') || rateLink;
        if (e.clientY < titleRow.getBoundingClientRect().top || e.clientY > last.getBoundingClientRect().bottom) return;
      }
      rateLink.click();
    });
  }

  /* ---------- Judge.me widget labels in the page language (the app does not translate them here) ---------- */
  var jmSrc = document.querySelector('script[data-jm-i18n]');
  if (jmSrc) {
    var jmMap = null; try { jmMap = JSON.parse(jmSrc.textContent); } catch (e) {}
    if (jmMap) {
      var jmBusy = 0;
      var jmFix = function () {
        jmBusy = 0;
        var box = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
        if (!box) return;
        var w = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null), n;
        while ((n = w.nextNode())) { var t = n.nodeValue.trim(); if (jmMap[t] && jmMap[t] !== t) n.nodeValue = n.nodeValue.replace(t, jmMap[t]); }
      };
      var jmLater = function () { if (!jmBusy) jmBusy = setTimeout(jmFix, 250); };
      jmFix();
      if ('MutationObserver' in window) new MutationObserver(jmLater).observe(document.getElementById('judgeme_product_reviews') || document.body, { childList: true, subtree: true });
    }
  }
})(document);
